<template>
  <div id="playbackInput" class="menuSection">
    <p class="optionDescription">
      Du kannst deine Aufnahme immer wieder anhören. Dafür schicken wir dir
      einen Link per E-Mail nach Erhalt deines Posters.
    </p>
    <div class="optionInput oi-color">
      <div v-for="(optionValue, optionKey) in playbackOptions" :key="optionKey">
        <input
          type="checkbox"
          :id="optionKey"
          :checked="playbackOptions[optionKey]"
          @change="change(optionKey)"
        />
        <label :for="optionKey" class="optionLabel">
          <p class="inputName">Zusätzlich, QR-Code auf Poster drucken</p>
          <div class="checkbox">
            <img class="checkmark" src="../../assets/img/ic_check.svg" />
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaybackInput',
  props: {
    playbackOptions: Object,
  },
  methods: {
    change(optionKey) {
      this.playbackOptions[optionKey] = !this.playbackOptions[optionKey]
    },
  },
}
</script>
